import React from "react";
import Select from "react-select";
import { capitalizeText } from "../../helpers";

const SourceFilterDropdown = (props) => {
  const { options = [], selectedValue, onSelect, className = "" } = props;

  const selectOptions = options.map((option) => ({
    label: option === "all" ? "All" : capitalizeText(option),
    value: option,
  }));

  const selectedOption =
    selectOptions.find((o) => o.value === selectedValue) || null;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#14C49B",
      borderColor: "#14C49B",
      borderRadius: "0.42rem",
      minHeight: "38px",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(20, 196, 155, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#11a885",
        backgroundColor: "#11a885",
      },
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#FFFFFF",
      fontWeight: "500",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(255, 255, 255, 0.8)",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#FFFFFF",
      "&:hover": {
        color: "#FFFFFF",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.42rem",
      boxShadow: "0px 0px 50px 0px rgba(82, 63, 105, 0.15)",
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#14C49B"
        : state.isFocused
        ? "#e8f9f5"
        : "transparent",
      color: state.isSelected ? "#FFFFFF" : "#3F4254",
      fontSize: "0.9rem",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#14C49B",
      },
    }),
  };

  const handleChange = (option) => {
    onSelect(option.value);
  };

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <div style={{ minWidth: "150px", maxWidth: "20vw" }}>
        <Select
          options={selectOptions}
          value={selectedOption}
          onChange={handleChange}
          styles={customStyles}
          isSearchable={false}
          placeholder="Select Source..."
        />
      </div>
    </div>
  );
};

export default SourceFilterDropdown;
